export default __webpack_public_path__ + "static/media/microfinance.01859e90.jpg";